import Home from "./Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Trades from "./trades/Trades";
import Portfolio from "./portfolio/Portfolio";
import Seeting from "./seetings/Seeting";
import Login from "./Login";
import Mcxwatchlist from "./watchlist/Mcxwatchlist";
import Markettrade from "./markettrade/Markettrade";
import Test from "./test";
import Logout from "./logout/Logout";
import Wallethistory from "./seetings/Wallethistory";
import Profile from "./seetings/Profile";
import Forgotpassword from "./seetings/Forgotpassword";
import Paindingtrade from "./trades/Paindingtrade";
import Activetrade from "./trades/Activetrade";
import Closetrade from "./trades/Closetrade";
import Logoutmodule from "./logout/Logoutmodule";
import Notification from "./seetings/Notification";
import Mcxnfo from "./watchlist/niftyoption";
import Niftyoptionmarkettrade from "./markettrade/Niftyoptionmarkettrade";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/" element={<Home />}></Route>
        <Route path="/trades" element={<Trades />}></Route>
        <Route path="/portfolio" element={<Portfolio />}></Route>
        <Route path="/account" element={<Seeting />}></Route>
        <Route path="/mcxwatchlist" element={<Mcxwatchlist />}></Route>
        <Route path="/markettrade" element={<Markettrade />}></Route>
        <Route path="/test" element={<Test />}></Route>
        <Route path="/wallethistory" element={<Wallethistory />}></Route>
        <Route path="/profile" element={<Profile />}></Route>
        <Route path="/forgotpassword" element={<Forgotpassword />}></Route>
        <Route path="/seeting" element={<Seeting />}></Route>
        <Route path="/logout" element={<Logout />}></Route>
        <Route path="/paindingtrade" element={<Paindingtrade />}></Route>
        <Route path="/activetrade" element={<Activetrade />}></Route>
        <Route path="/closetrade" element={<Closetrade />}></Route>
        <Route path="/logoutmodule" element={<Logoutmodule />}></Route>
        <Route path="/notification" element={<Notification />}></Route>
        <Route path="/mcxnfo" element={<Mcxnfo />}></Route>
        <Route
          path="/niftyoptionmarkettrade"
          element={<Niftyoptionmarkettrade />}
        ></Route>
      </Routes>
    </Router>
  );
}
   export default App;
